import React, { createContext } from 'react'
import { MenuOutlined } from '@ant-design/icons'
import './sortable-list.scss'
import { Draggable } from 'react-beautiful-dnd'

const DragHandleContext = createContext()

export function SortableItem({ children, id, index, disabled = false }) {
    // If disabled, render without Draggable wrapper
    if (disabled) {
        return (
            <li className='SortableItem SortableItem--disabled'>
                <DragHandleContext.Provider value={null}>{children}</DragHandleContext.Provider>
            </li>
        )
    }

    return (
        <Draggable draggableId={id} index={index} isDragDisabled={disabled}>
            {provided => (
                <li className='SortableItem' ref={provided.innerRef} {...provided.draggableProps}>
                    <DragHandleContext.Provider value={provided.dragHandleProps}>{children}</DragHandleContext.Provider>
                </li>
            )}
        </Draggable>
    )
}

export function DragHandle({ tooltipText = 'Move item', disabled = false }) {
    const dragHandleProps = React.useContext(DragHandleContext)
    const isDisabled = disabled || !dragHandleProps

    return (
        <div
            className={`DragHandle d-flex-center m-8 ${isDisabled ? 'DragHandle--disabled' : ''}`}
            title={isDisabled ? 'Item cannot be moved' : tooltipText}
            {...(isDisabled ? {} : dragHandleProps)}
        >
            <MenuOutlined />
        </div>
    )
}
